module.exports = "https://static.wmbcdn.com/uniweb/images/c86821d6f143b98c61a9137da09d258e.svg";